import PeopleDetailsModal from "./PeopleDetailsModal";

export default PeopleDetailsModal;